__webpack_require__.p = "/Mint-react-page/";